module.exports = __webpack_public_path__ + "static/media/landing-featured-seller-bg.a67a2624.png";